import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Slider from 'react-slick'
import { EmtPaper, EmtTheme } from 'emt-components-v2'

type EmtThemeType = { theme: EmtTheme }

export const LightBox = styled(Box)<EmtThemeType>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '18px',
  flex: 1,
  borderRadius: '18px',
  border: `1px solid ${theme?.palette.greyGradient[100]}`,
  padding: '28px 32px',
  [theme?.breakpoints.down('md')]: { minHeight: 'auto' },
})) as typeof Box

export const LightBoxChips = styled(Box)(() => ({
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'start',
  flexWrap: 'wrap',
  ['& Mui-chip']: {
    display: 'none',
  },
}))

export const TrueFalseContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',
  '& .MuiChip-root': {
    width: 32,
    height: 32,
    borderRadius: '12px',
    '& .MuiChip-icon': { margin: 0 },
    '& .MuiChip-label': { display: 'none' },
  },
}))

export const TrueFalseItem = styled(Box)(() => ({
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  justifyContent: 'start',
}))

export const StickyCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'row',
  [theme.breakpoints.down('lg')]: {},
}))

export const Wrapper = styled(Box)(({ theme }) => ({
  background: 'white',
  [theme.breakpoints.down('md')]: {
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    position: 'relative',
    top: -30,
    zIndex: 2,
  },
}))

export const ProfileContainer = styled(Box)(({ theme }) => ({
  width: 775,
  display: 'flex',
  flexDirection: 'column',
  rowGap: '30px',
  paddingBottom: '30px',
  [theme.breakpoints.down('lg')]: {
    width: 700,
  },
  [theme.breakpoints.down(1080)]: {
    width: 600,
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}))

export const MobileSliderImage = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: 310,
  '& img': {
    width: '100%',
    alignSelf: 'center',
    objectFit: 'cover',
    [theme.breakpoints.up(600)]: {
      height: 480,
    },
  },
}))

export const StyledSlider = styled(Slider)<EmtThemeType>(({ theme }) => ({
  touchAction: 'pan-x',
  '& .slick-list, & .slick-track, & .slick-slide': {
    touchAction: 'pan-x',
  },
  '& .swiper-slide': {
    padding: '1px',
  },
  '& .slick-dots': {
    bottom: 50,
    '& li': {
      width: 12,
      height: 12,
      border: `1px solid ${theme.palette.greyGradient[150]}`,
      background: theme.palette.common.white,
      opacity: 1,
      borderRadius: '100%',
      '&.slick-active': {
        borderColor: theme.palette.primary.main,
        background: theme.palette.primary.main,
      },
    },
  },
}))

export const ProfileSidebar = styled(Box)(({ theme }) => ({
  position: 'sticky',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '18px',
  flex: 1,
  alignSelf: 'flex-start',
  top: 30,
  marginBottom: 30,
  [theme.breakpoints.down('md')]: {},
}))

export const MobileUserOptions: any = styled(EmtPaper)(() => ({
  padding: '24px',
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '20px',
  boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.08), 0px 4px 48px rgba(0, 0, 0, 0.08);',
  position: 'absolute',
  top: '50px',
  zIndex: 2,
  right: '14px',
  textAlign: 'left',
  alignItems: 'flex-start',
}))
